import { TableDaySubRow } from '../../../manager/TimeSheetsControlling/Tables/types';

export const defaultColumns = {
  targetMinutes: true,
  startTime: true,
  endTime: true,
  breakMinutes: true,
  workedMinutes: true,
  workedDifferenceMinutes: true,
  commentsCount: true,
  timeBalanceAccumulatedMinutes: true,
} as const;

type ColumnId = keyof typeof defaultColumns;

export const timeSheetColumnIds: ColumnId[] = Array.from(
  Object.keys(defaultColumns),
) as ColumnId[]; // If you know how to remove 'as' here please write me.

export type TimeSheetColumnId = Extract<
  keyof TableDaySubRow, // to be on the more safe side
  ColumnId
>;

// A column id is either a built-in column or a dynamic time-entry extra-field
// column (identified by its Salesforce field API name). Kept as a plain string
// so persisted settings tolerate ids that are unknown in a given org.
export type TimeSheetColumnSetting = {
  id: string;
  checked: boolean;
};

// A dynamic column backed by a flair__Extra_Table_Field__mdt record.
export type ExtraFieldColumnDef = {
  id: string;
  title: string;
  defaultChecked: boolean;
};
